import { makeStyles } from '@material-ui/core/styles';
import "./WinnersStages.scss";
import Grid from "@material-ui/core/Grid";
import Container from "react-bootstrap/Container";

const useStyles = makeStyles(() => ({
  containers: {
    position: 'relative',
  },
  WinnerWrapper: {
    width: "100%",
    flexGrow: 1,
    marginBottom: "65px",
  }
}));

interface WinnersStagesProps {
  index: number;
}

export function WinnersStages(props: WinnersStagesProps) {
  const classes = useStyles();

  let phase1Classname = "pending";
  let phase2Classname = "pending";
  let phase3Classname = "pending";

  if (props.index === 0) {
    phase1Classname = "pending";
    phase2Classname = "pending";
    phase3Classname = "pending";
  }

  if (props.index === 1) {
    phase1Classname = "inprogress";
    phase2Classname = "pending";
    phase3Classname = "pending";
  }

  if (props.index === 2) {
    phase1Classname = "complete";
    phase2Classname = "inprogress";
    phase3Classname = "pending";
  }

  if (props.index === 3) {
    phase1Classname = "complete";
    phase2Classname = "complete";
    phase3Classname = "inprogress";
  }

  if (props.index === 4) {
    phase1Classname = "complete";
    phase2Classname = "complete";
    phase3Classname = "complete";
  }

  return (
    <>
      <div className={classes.WinnerWrapper}>
        <Container>
          <Grid container className={classes.containers}>
            {/* Apply stage-complete class for Complete Status  */}
            <Grid item
              xs={4} className={`stage-${phase1Classname} stages winner-stage-link`}>
                <div className="wizard-outer-box active">
                  <div className="step-box step-1">
                    <h4>PHASE 1</h4>
                    <h3>
                      Auction in progress
                    </h3>
                    {/* Apply complete-status class for Complete Status  */}
                    <div className={`progress-box ${phase1Classname}-status`}>
                    </div>
                  </div>
                </div>
              <hr />
            </Grid>
            {/* Apply stage-inprogress class for Inprogress Status  */}
            <Grid item
              xs={4} className={`stage-${phase2Classname} stages winner-stage-link`}>
                {/* Apply active class in case of Inprogress Status  */}
                <div className="wizard-outer-box active">
                  <div className="step-box step-1">
                    <h4>PHASE 2</h4>
                    <h3>
                      Rewards distributed
                    </h3>
                    {/* Apply inprogress-status class for Inprogress Status  */}
                    <div className={`progress-box ${phase2Classname}-status`}>
                    </div>
                  </div>
                </div>
              <hr />
            </Grid>
            {/* Apply stage-pending class for Pending Status  */}
            <Grid item
              xs={4} className={`stage-${phase3Classname} stages winner-stage-link`}>
                <div className="wizard-outer-box active">
                  <div className="step-box step-1">
                    <h4>PHASE 3</h4>
                    <h3>
                    Auction funds unlocked
                    </h3>
                    {/* Apply pending-status class for Pending Status  */}
                    <div className={`progress-box ${phase3Classname}-status`}>
                    </div>
                  </div>
                </div>
            </Grid>
          </Grid>
        </Container>
      </div>
    </>
  );
}
